module.exports = __webpack_public_path__ + "static/media/Music-List-App.efc84b72.png";